import { AssetForm } from "@/components/forms/AssetForm";
import { useState, useRef } from "react";
import { QRScanner } from "@/components/scan/QRScanner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useTranslation } from "react-i18next";
import { supabase } from "@/integrations/supabase/client";

export default function CreateAsset() {
  const { t } = useTranslation();
  const [showCodeScanner, setShowCodeScanner] = useState(false);
  const formRef = useRef<{ setValue: (field: string, value: any) => void } | null>(null);

  const handleCodeScan = (code: string) => {
    if (formRef.current) {
      formRef.current.setValue("qr_id", code);
    }
    setShowCodeScanner(false);
  };

  return (
    <div className="max-w-2xl mx-auto p-4">
      <h1 className="text-2xl font-semibold mb-6">Create Asset</h1>
      <AssetForm 
        mode="create" 
        onShowCodeScanner={() => setShowCodeScanner(true)}
        formRef={formRef}
      />

      <Dialog 
        open={showCodeScanner} 
        onOpenChange={(open) => {
          setShowCodeScanner(open);
          if (!open) {
            // Ensure scanner is stopped when dialog closes
            setShowCodeScanner(false);
          }
        }}
      >
        <DialogContent className="sm:max-w-[600px]">
          <DialogHeader>
            <DialogTitle>{t('scanner.scanUniversalCode')}</DialogTitle>
          </DialogHeader>
          <div className="flex-1 overflow-y-auto">
            <QRScanner
              onScan={handleCodeScan}
              supabaseClient={supabase}
            />
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}